/* maaho-basket-limit.js - how many made-to-measure lines a basket holds, for the
   cart drawer (assets/maaho-header.js) and the product page (assets/maaho-product.js).

   A made-to-measure line carries the hidden _measurements or _options property; its
   quantity does not count. The pricing guard function counts the same way and refuses
   the checkout above the limit. The limit and its message come from the page, from
   snippets/maaho-made-to-measure-limit.liquid and maaho.cart.made_to_measure_limit. */

window.MaahoBasketLimit = (function () {
  'use strict';

  /** A comma-separated property holding at least one value. */
  function hasValue(value) {
    return String(value == null ? '' : value).split(',').some(function (part) {
      return part.trim() !== '';
    });
  }

  function isMadeToMeasure(properties) {
    var lineProperties = properties || {};
    return hasValue(lineProperties._measurements) || hasValue(lineProperties._options);
  }

  /** Lines of a /cart.js response, each with its own properties. */
  function countMadeToMeasureLines(items) {
    return (items || []).filter(function (item) {
      return isMadeToMeasure(item.properties);
    }).length;
  }

  return {
    isMadeToMeasure: isMadeToMeasure,
    countMadeToMeasureLines: countMadeToMeasureLines
  };
})();
